import React from "react";
import BlogComponent from "../components/components-blog";
import ChangePageTitle from "../components/change-title-page";
// import axios from "axios";
// import { useState, useEffect } from "react";
import { useBlogHeader } from "../hooks/apis/headers";

function Blog() {
  const { data: blogData, isLoading, error } = useBlogHeader();

  //   const [blogTitle, setblogTitle] = useState("");

  //   useEffect(() => {
  //     axios
  //       .get("https://panel.baghban.restaurant/api/header/blog")
  //       .then((response) => {
  //         setblogTitle(response.data.title);
  //         // setslideText(response.data.spotlites[0].text);
  //         console.log(response.data);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   }, []);

  if (isLoading)
    return (
      <div className={isLoading ? "active loading" : "loading"}>
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
    );
  if (error) return <p>Error</p>;
  return (
    <>
      <ChangePageTitle pageTitle={blogData.title} />
      <BlogComponent />
    </>
  );
}

export default Blog;
